<p-fluid>
    <div class="flex flex-col gap-2">
        <label class="block font-medium mb-1">Sumsub Level Name</label>
        <input pInputText class="w-full" [disabled]="disabled()" [ngModel]="value().LevelName" (ngModelChange)="setField('LevelName', $event ?? '')" />
        <small class="text-muted-color">The Sumsub verification level applied to users of this category.</small>
    </div>
</p-fluid>
